import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './ControlButtons.scss'

const ControlButtons = ({ onCart, onLeft, onRight }) => {
  return (
    <div className='ou_buttons'>
      <CSSTransitionGroup
        transitionName='ou_bottom-button'
        transitionEnterTimeout={350}
        transitionLeaveTimeout={250}
      >
        {onCart && <div className='ou_cart-button' onClick={onCart} />}
        {onLeft && <div className='ou_bottom-button ou_bottom-button--left' key='left' onClick={onLeft} />}
        {onRight && <div className='ou_bottom-button ou_bottom-button--right' key='right' onClick={onRight} />}
      </CSSTransitionGroup>
    </div>
  )
}

ControlButtons.propTypes = {
  onCart: PropTypes.func,
  onLeft: PropTypes.func,
  onRight: PropTypes.func,
}

export default ControlButtons



// WEBPACK FOOTER //
// ./src/templates/outSide/components/showcase/ControlButtons.js